import { render, staticRenderFns } from "./deleteMainCategory.vue?vue&type=template&id=7564354b"
import script from "./deleteMainCategory.vue?vue&type=script&lang=js"
export * from "./deleteMainCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports